import { responsiveFontSizes } from '@material-ui/core/styles';
import { orange, grey, blue } from '@material-ui/core/colors';
import { createTheme } from '@material-ui/core/styles';

let theme = createTheme({
  typography: {
    useNextVariants: true,
    fontFamily: ['Visuelt', 'Roboto', 'Helvectica Neue', 'Helvetica', 'Arial', 'sans-serif']
  },
  palette: {
    primary: {
      main: '#00000',
      themeColor: '#01B5DE',
      dark: '#335977',
      yellow: '#FFE785',
      faded: '#C9C9C9',
      lightBlack: '#5C5C5C',
      dataBlack: '#999999',
      white: '#FFFFFF',
      mainText: '#545456',
      mainText2: '#545456',
      subText: '#6F6F6F',
      disableBg: '#F6F6F6',
      header: '#00b6de',
      smartEvCard: '#FFF',
      headerTitle: '#FFFFFF',
      cards: '#FFFFFF',
      cardsBox: '0px 0px 6px #00000029',
      heading: '#545456',
      border: '1px solid #70707033',
      borderColor: '#70707033',
      disabledText: 'rgba(169, 169, 170, 1)',
      underline: 'rgba(0, 0, 0, 0.42)',
      background: "#F6F7FB",
      popupBackground: '#fff',
      text: '#6F6F6F',
      progress: '1px solid rgb(112, 112, 112, 0.2)',
      hint: '#6F6F8C',
      highlight: '#4D4A4A',
      subHeading: '#000000',
      title: '#B7B7B7',
      hover: '#FFFCF7',
      label: '#6F6F6F',
      msgText:"#7B8793",
      arrowIcon: "#a1a1a2",
      subHeader: "#545456",
      toastBackground: "#545456",
      cardBackground: "#FFFFFF",
      mainHeading: "#6B7073",
      errorToastBackground: "#ff5959",
      popupDivider: "#DFDFDF",
      cardText: "#545456",
      emptyStateTextColor: "#999999",
      dashedBorderColor: "#BABEC3",
      inputLabelColor: '#a2abb3',
      iqAirSettingsCardColor: "#F6F7FB",
      iqAirSettingsCardIconBorder: "#DFDFDF",
      iqAirSettingsCardIconBg: "#FFF",
      dropdownBorder:'#BABEC3',
      ...orange
    },
    secondary: {
      main: '#01B4DE',
      link: '#47B5DE',
      text: '#6F6F6F',
      background: '#F6F7FB',
      subHeader: '#545456',
      arrowIcon: '#a1a1a2',
      subHeading: "#6B7073",
      ...blue
    },
    tertiary: {
      main: '#FFFFFF',
      light: '#FAFAFA',
      dark: '#7E7E7E',
      card:"#FFFFFF",
      cardText:"#545456",
      boxText:"#6F6F6F",
      container:"#FFFFFF",
      background: '#F6F7FB',
      sheetContainer:"#FFFFFF",
      tabBorder:"#f1e8e8",
      tabBackground:"#F5F5F8",
      inputBox:"#FFFFFF",
      titleBox: "#545456",
      NoEvDataMessage : '#939598',
      drawerContent: "#545456",
      buttonColor:"#F8F8FA",
      labelText:"#545456",
      inputText:"#939598",
      commonText:"#A9A9AA",
      infoIcon:'#BABEC3',
      headingText:"#545456",
      headingText2:"#6B7073",
      popUpHeading:"#545456",
      popUpContent:"#545456",
      popupHeadingBorder:"#C6C8CA80",
      popupActionButtonBorder: "#D8DCDE80",
      dividerBorderColor: "#D8DCDE",
      popupTitleText:"#131415",
      closeIconColor: '#6F6F6F',
      timeCardBtn : '#FFFFFF',
      applyDisabledColor : '#FFFFFF',
      lightColor: '#6B7073',
      chargerTitle: '#545456',
      chargerInfo: '#545456',
      chargerImageBackgroundColor: '#FFFFFF',
      liveStatusTitle: '#545456',
      provisiningSubHeading : '#6B7073',
      updatePopUpTitle: '#111',
      timePickBackgroundColor: '#FFFFFF',
      timePickBackgroundColorForChargingModes: '#FFFFFF',
      clockIconColor: '#545456',
      ChargeIconOuterFill: '#FFFFFF',
      drawerBackgroundColor : '#FFFFFF',
      evDetailsBackgroundColor: '#FFFFFF',
      evDetailsDataColor: "#7B8793",
      blackText : '#131415',
      dividerBackgroundColor: '#C6C8CA',
      muiDivider: 'rgba(0,0,0,0.12)',
      errorMessageColor : "#f44336",
      toggleButtonColor : "#D0D0D0",
      radioButtonColor : '#6B7073',
      radioButtonCheckedColor : '#01B4DE',
      radioButtonDisabledColor: '#BABEC3',
      schedulesCustomTimes : '#6B7073',
      provisionDisableButton : '#7ed7ec',
      provisionEnableButton : '#01B5DE', 
      provisionBordercolor: '#01B5DE', 
      provisionRestartBtn : '#FFFFFF',
      lighter: grey[100],
      permissionDesc:'#F6F7FB',
      permissionTextLight: '#545456',
      disableButton: '#DFDFDF',
      loaderTile: '#DFDFDF',
      quickTipsInfoMsg: '#545456',
      swiperBullets: '#BBBEC2',
      noteBox:'#e6e8f4',
      swiperActiveBullet: '#6C7073',
      disableApplyButtonBg: '#BABEC3',
      disableApplyButtonText: '#6B7073',
      inputLabel: '#A9A9AA',
      wireConfigKnowMore: "#6F6F6F",
      drawerBackgroundV2: "#FFFFFF",
      sliderValue:"#01B5DE",
      buttonV2: "#01B5DE",
      disabledLinkButton: '#a2abb3',
      subtextV2: "#6B7073",
      sliderCardBackground: "#F6F7FB",
      checkBoxConfirmationBackground: "#f6f7fb",
      checkBoxBorder: "#6B7073",
      checkBoxFill: "#01B5DE",
      commonButtonBackground : "#01B5DE",
      learnMoreBgv: "#F0FBFD",
      arrowIcon: "#01B5DE",
      subHeader: "#01B5DE",
      greyedOutText: "#B7B7B7",
      connectionMediumContainer: "#ffffff",
      noticeBorder: "#6B7073",
      ...grey
    },
    icon: {
      default: '#545456',
      svgIcon:"#01a1c6",
      wifiIcon:"#ddd"
    }
  },
  overrides: {
    MuiStepIcon: {
      text: {
        fontSize: '13px',
        '&$active': {
          // color: '#F3731F'
        },

        fontWeight: 'bold',
        fill: '#FFFFFF'
      },
      root: {
        '&$active': {
          // color: '#F3731F'
        }
      }
    }
  }
});

theme = responsiveFontSizes(theme);

export default theme;
